export const capitalizeWords = (str) => {
  if (!str) return ""; // Handle empty or null input
  return str
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join the words back into a single string
};
